export const DEFAULT_ERROR_MESSAGES = {
	min: 'common.validation.min',
	max: 'common.validation.max',
	minLength: 'common.validation.minlength',
	maxLength: 'common.validation.maxlength',
	pattern: 'common.validation.pattern',
	incorrectDate: 'common.validation.incorrectDate',
	email: 'common.validation.email',
	passwordError: 'common.validation.password.error',
};
